import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { useAuthUserContext } from '../../providers'
import { Donor, ApiDonor } from '../../models/Donor';
import Spinner from '../../components/Spinner';

type Props = {
  setHasDraftCheckup: (value: boolean) => void;
}

const NewbieMessageDonor = ({ setHasDraftCheckup }: Props) => {
  const authUser = useAuthUserContext().user;
  const [ donor, setDonor ] = useState<Donor>();
  const { get, loading } = useApi();

  useEffect(() => {
    get({
      endpoint: `/api/v1/donors/${ authUser?.userId }`,
      onSuccess: (res) => {
        const apiDonor: ApiDonor = res.data;
        const donorData = new Donor(apiDonor);
        setDonor(donorData);

        const hasDraft = donorData.std.status === 'DRAFT' || donorData.semen.status === 'DRAFT';
        setHasDraftCheckup(hasDraft);
      },
      onError: (err) => {
        console.error(`[GET FAILED] /api/v1/donors/${ authUser?.userId }`);
      },
    });
  }, [ get, authUser?.userId, setHasDraftCheckup ])

  return (
    <div className="border_box">
      { !loading && !donor?.isKycCertified && (
        <div className="newbie_message">
          <strong>初めてご利用の方へ</strong>
          <p>Ton Bébéにご登録いただきありがとうございます。</p>
          <p>初めてご利用になられる方には、まずは<Link to="/mypage/kyc">本人確認</Link>をお願いしております。</p>
          <p>その後、<Link to="/mypage/profile">プロフィール</Link>の入力と公開、<Link to="/mypage/checkups">検査結果の書類提出</Link>を行なってください。</p>
          <p>検査結果の登録を行うことでドニーからの信頼度が高まり、提供の機会が増えます。</p>
          <p>※このメッセージは本人確認を提出すると表示されなくなります。</p>
        </div>
      ) }

      <div className="status">
        <section>
          <h3 className="sub_title">登録状況</h3>
          <div className="wrap">
            <dl className="graf_list">
              <dt>本人確認</dt>
              <dd>
                { loading ? <Spinner size="small" /> : donor?.isKycCertified ? <span className="done">登録済</span> : <span>未登録 (<Link to="/mypage/kyc">登録する</Link>)</span> }
              </dd>
              <dt>プロフィール</dt>
              <dd>
                { loading ? <Spinner size="small" /> : donor?.basicInfo.isPublic ? <span className="done">公開済</span> : <span>未公開 (<Link to="/mypage/profile">編集する</Link>)</span> }
              </dd>
              <dt>性病検査</dt>
              <dd>
                { loading ? <Spinner size="small" /> : donor?.std.certified ? <span className="done">登録済</span> : <span>未登録 (<Link to="/mypage/checkups/std">登録する</Link>)</span> }
              </dd>
              <dt>精液検査</dt>
              <dd>
                { loading ? <Spinner size="small" /> : donor?.semen.certified ? <span className="done">登録済</span> : <span>未登録 (<Link to="/mypage/checkups/semen">登録する</Link>)</span> }
              </dd>
            </dl>
          </div>
        </section>
      </div>
    </div>
  );
}

export default NewbieMessageDonor;
